import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import EcallProcessPc from './components/EcallProcessPc';
import useIsMobile from '../../hook/useIsMobile';
import EcallProcessMobile from './components/EcallProcessMobile';

export default function BusinessPage() {

  const navigate = useNavigate();

  const isMobile = useIsMobile();

  return (
    <div>
      <Header />
      <main>
        <section
          data-bg-type='colorful'
          className='relative w-full h-screen flex items-center justify-center text-title2 lg:text-display1 text-white text-center'
        >
          <img
            className='absolute inset-0 w-full h-screen object-cover object-center z-[-2]'
            src={`${process.env.REACT_APP_STATIC_URL}/images/Business/Main_Section_Background.jpg`}
            alt='배경'
          />
          <div className='absolute inset-0 w-full h-screen z-[-1] bg-black opacity-15' />

          모빌리티 주행 사고 실시간 감지 및<br />
          자동 구조요청 서비스
        </section>

        <section
          data-bg-type='white'
          className='wrapper w-full mt-[120px] lg:mt-[320px]'
        >
          <div className='px-[10%] text-center text-title3 font-bold lg:text-display2 text-label-500'>
            주행 사고 실시간 감지 및 자동 구조요청 시스템
          </div>

          <div
            className="w-full flex justify-center items-center rounded-[28px] mt-[60px] lg:mt-[80px] px-[30px] py-[30px] lg:py-[80px] bg-[#FAFAFA]">
            <img
              src={`${process.env.REACT_APP_STATIC_URL}/images/Business/System_Graph.jpg`}
              alt='주행 사고 실시간 감지 및 자동 구조요청 시스템'
            />
          </div>
        </section>

        {isMobile ? <EcallProcessMobile /> : <EcallProcessPc />}

        <section
          data-bg-type='white'
          className='w-full mt-[120px] lg:mt-[320px]'
        >
          <div className='px-[10%] text-center text-title3 font-bold lg:text-display2 text-label-500'>
            제품 및 서비스
          </div>

          <a href='https://www.link-call.co.kr'>
            <div className='flex gap-[30px] bg-[#FAFAFA] w-full h-[500px] lg:h-auto lg:wrapper max-w-[800px] lg:max-w-[1200px] mx-auto mt-[60px] lg:mt-[80px] lg:rounded-[28px] cursor-pointer'>
              <img
                className='hidden lg:block w-[500px] m-[50px] object-cover'
                src={`${process.env.REACT_APP_STATIC_URL}/images/Business/Service_Linkcall.png`}
                href='링콜'
              />

              <div className='mx-[30px] mt-[80px]'>
                <img
                  className='w-[120px]'
                  alt='링콜'
                  src='https://link-call.co.kr/logo.png'
                />
                <div className='mt-[30px] text-title3 text-label-400'>
                  장애인과 고령자의 안전을 위한<br />
                  주행 사고 자동 신고 솔루션
                </div>

                <div className='mt-[30px] text-heading2 font-semibold text-label-400 flex items-center gap-[12px] cursor-pointer'>
                  자세히 보기
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M647-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h447L451-716q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l264 264q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L508-188q-11 11-27.5 11T452-188q-12-12-12-28.5t12-28.5l195-195Z" /></svg>
                </div>
              </div>
            </div>
          </a>
        </section>

        <div className='flex flex-wrap items-center justify-center gap-[15px] lg:gap-[30px] mt-[80px] lg:mt-[140px]'>
          <a href='https://www.chilgok.go.kr/main.do' target='_blank'><img className='h-[30px] lg:h-[60px]' src={`${process.env.REACT_APP_STATIC_URL}/images/Business/company/chilgok_logo.png`} alt='칠곡군' /></a>
          <a href='http://www.seniorgn.co.kr' target='_blank'><img className='h-[30px] lg:h-[60px]' src={`${process.env.REACT_APP_STATIC_URL}/images/Business/company/seniorgn_logo.png`} alt='사단법인 대한노인회 강남구지회' /></a>
          <a href='http://hgdaycare.co.kr' target='_blank'><img className='h-[30px] lg:h-[60px]' src={`${process.env.REACT_APP_STATIC_URL}/images/Business/company/hgdaycare_logo.png`} alt='할렐루야 광주 주간보호센터' /></a>
        </div>

      </main>

      <div className='h-[100px]' />
      <Footer />
    </div>
  )
}